module.exports = __webpack_public_path__ + "r-v3/img/sticker_14.bd9177ef.svg";